import React, { useEffect, useRef, useState } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { useHistory, useLocation } from 'react-router-dom';

import { Competency } from 'assets/assetsV1/iconComponents';

import { Button, BUTTON_VARIANT } from 'uiToolkitV1/Button';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

import { useGetLevelUpDetailsQuery } from '../dataHooks';
import { useCompetencyQueryParams } from '../helpers/useCompetencyQueryParams';

export const Header = () => {
  const descriptionContainerRef = useRef<HTMLDivElement>(null);
  const descriptionRef = useRef<HTMLDivElement>(null);
  const [showReadMore, setShowReadMore] = useState(false);

  const { data: levelUpCompetencyDetails } = useGetLevelUpDetailsQuery();

  const history = useHistory();
  const location = useLocation();

  const { competencyId } = useCompetencyQueryParams();

  const goToCompetencyDetails = () => {
    const queryParams = new URLSearchParams(location.search);
    queryParams.set('scrollToId', 'details');
    history.push({
      search: queryParams.toString(),
    });
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!descriptionContainerRef?.current || !descriptionRef?.current) {
      return;
    }

    const resizeObserver = new ResizeObserver(() => {
      const { scrollWidth } = descriptionRef.current ?? {};
      const { clientWidth } = descriptionContainerRef.current ?? {};
      setShowReadMore(scrollWidth > clientWidth);
    });
    resizeObserver.observe(descriptionContainerRef.current);

    // eslint-disable-next-line consistent-return
    return () => {
      resizeObserver.disconnect();
    };
    // need to ignore dependency warning here, because across panel reopens, there's some caching of ref which is letting us apply resize observer on second onwards rerender
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [descriptionContainerRef?.current, descriptionRef?.current]);

  if (!competencyId) {
    return null;
  }

  return (
    <Flex flexDir="column" px={4} py={3}>
      <Flex color="text.g2" alignItems="center" gap={1}>
        <Competency fill="transparent" />
        <TextBodyMedium bold color="text.g1">
          {levelUpCompetencyDetails?.name}
        </TextBodyMedium>
      </Flex>
      <Flex alignItems="center" ref={descriptionContainerRef}>
        <Box ref={descriptionRef} overflow="hidden">
          <TextLabel color="text.g2" whiteSpace="nowrap">
            {levelUpCompetencyDetails?.competencyDescription}
          </TextLabel>
        </Box>
        {showReadMore && (
          <Button variant={BUTTON_VARIANT.tertiary} onClick={goToCompetencyDetails}>
            read more
          </Button>
        )}
      </Flex>
    </Flex>
  );
};
